<template>
  <div class="sp-index__calendar">
    <div class="sp-index__calendar-left">
      <div class="sp-index__calendar-legend">
        <span><i class="legend-color legend-rest"></i>休息</span>
        <span><i class="legend-color legend-office-rest"></i>日本事务所休息</span>
        <span><i class="legend-color legend-holiday-work"></i>调休</span>
        <span><i class="legend-color legend-work"></i>工作日</span>
      </div>
      <el-calendar v-model="valueTime">
        <template slot="dateCell" slot-scope="{ date, data }">
          <el-tooltip
            :content="getHolidayDescription(data)"
            :disabled="!getHolidayDescription(data)"
            placement="top"
            effect="light"
            class="calendar-cell-tooltip"
            popper-class="calendar-description-tooltip"
          >
            <div :class="['sp-index__calendar-item', getDateClass(data)]" @click="showEditDialog(data)">
              {{ formatDate(data.day) }}
              <small v-if="isSpecialStatus('adjustment', data)" class="sp-index__calendar-work">班</small>
              <small
                v-if="isSpecialStatus(['holiday-rest', 'rest', 'weekend'], data)"
                :class="['sp-index__calendar-reset', { 'office-reset': isSpecialStatus('holiday-rest', data) }]"
              >休</small>
            </div>
          </el-tooltip>
        </template>
      </el-calendar>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog :visible.sync="dialogVisible" title="编辑日期状态" width="30%">
      <el-form :model="selectedDate" label-width="100px" v-if="dialogVisible">
        <el-form-item label="日期">
          <el-input v-model="selectedDate.formattedDay" disabled></el-input>
        </el-form-item>
        <el-form-item label="日期状态">
          <el-radio-group v-model="selectedDate.status">
            <el-radio label="rest">休息</el-radio>
            <el-radio label="adjustment">调休</el-radio>
            <el-radio label="holiday-rest">日本事务所休息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="节日描述(日)">
          <el-input v-model="selectedDate.holidayName" type="textarea" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="danger" @click="delDateStatus(selectedDate.id)" v-if="selectedDate.id">重置</el-button>
        <el-button type="primary" @click="saveDateStatus">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const enumApis = {
      get: '/system/configurationCalendar/list',
      add: '/system/configurationCalendar/add',
      del: '/system/configurationCalendar/del'
    }
    return {
      enumApis,
      valueTime: new Date(),
      specialDates: [],
      dialogVisible: false,
      selectedDate: {
        id: undefined,
        holidayName: '',
        day: '',
        formattedDay: '',
        status: 'work'
      }
    };
  },
  watch: {
    valueTime(newVal, oldVal) {
      if (newVal.getMonth() !== oldVal.getMonth() || newVal.getFullYear() !== oldVal.getFullYear()) {
        this.fetchSpecialDates();
      }
    }
  },
  methods: {
    fetchSpecialDates() {
      const year = this.valueTime.getFullYear();
      this.$http.get(this.enumApis.get, {
        params: {
          pageNum: 1,
          pageSize: 366,
          year
        }
      }).then(res => {
        const list = res && res.data && res.data.data && res.data.data.list
          ? res.data.data.list
          : [];
        this.specialDates = list.map(item => {
          const obj = {
            id: item.id,
            date: String(item.date || item.dateStr || '').replace('T', ' ').split(' ')[0],
            status: item.status,
            isRest: item.isRest - 0,
            holidayName: item.holidayName
          }
          return obj
        })
      }).catch(() => {
        this.$message.error('日历配置加载失败');
        this.specialDates = [];
      });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${month}-${day}`;
    },
    getHolidayDescription(data) {
      const formattedDate = this.getFormattedDate(new Date(data.day));
      const specialDate = this.specialDates.find(item =>
        this.getFormattedDate(new Date(item.date)) === formattedDate
      );
      return specialDate ? (specialDate.holidayName || '') : '';
    },
    getFormattedDate(date, format = 'ymd') {
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      return format === 'ymd' ? `${y}-${m}-${d}` : `${y}-${m}`;
    },
    getSpecialStatus(data) {
      const formattedDate = this.getFormattedDate(new Date(data.day));
      const specialDate = this.specialDates.find(item => {
        return this.getFormattedDate(new Date(item.date)) === formattedDate
      });
      if (specialDate) {
        switch (specialDate.status) {
          case 'rest':
            return { value: 'rest', label: '休班' };
          case 'adjustment':
            return { value: 'adjustment', label: '调休' };
          case 'holiday-rest':
            return { value: 'holiday-rest', label: `${specialDate.holidayName || '日本事务所休息'}` };
          case 'holiday-work':
            return { value: 'holiday-work', label: `${specialDate.holidayName || '节假日'}` };
          case 'holiday':
            return {
              value: specialDate.isRest ? 'holiday-rest' : 'holiday-work',
              label: `${specialDate.holidayName || '节假日'}`
            };
          default:
            console.warn(`Unexpected status for ${formattedDate}: ${specialDate.status}`);
            return { value: '', label: '未知状态' };
        }
      }

      const dayOfWeek = new Date(data.day).getDay(); // 0 表示周日, 6 表示周六
      if (dayOfWeek === 0) {
        return { value: 'weekend', label: '休息' }; // 默认周日为休息
      }

      return { value: 'work', label: '上班' };
    },
    isSpecialStatus(statuses, data) {
      if (!Array.isArray(statuses)) statuses = [statuses];
      return statuses.includes(this.getSpecialStatus(data).value);
    },
    getDateClass(data) {
      const status = this.getSpecialStatus(data);

      switch (status.value) {
        case 'rest':
          return 'rest-day';
        case 'adjustment':
          return 'adjustment-day';
        case 'weekend':
          return 'weekend-restday';
        case 'holiday-rest':
          return 'japan-office-rest';
        case 'holiday-work':
          return 'holiday-work';
        case 'work':
          return 'workday';
        default:
          console.warn(`Unexpected status encountered: ${status.value}`);
          return ''; // 或者你可以选择一个默认的类名
      }
    },
    showEditDialog(data) {
      this.selectedDate.day = this.getFormattedDate(new Date(data.day));
      this.selectedDate.formattedDay = this.formatDate(this.selectedDate.day);
      
      // 根据日期查找 specialDates 中对应的条目
      const formattedSelectedDate = this.getFormattedDate(new Date(this.selectedDate.day), 'ymd');
      const existingSpecialDate = this.specialDates.find(item => 
        this.getFormattedDate(new Date(item.date), 'ymd') === formattedSelectedDate
      );

      if (existingSpecialDate) {
        // 如果找到了对应条目，则用这些数据填充 selectedDate
        this.selectedDate.id = existingSpecialDate.id;
        this.selectedDate.status = existingSpecialDate.status;
        this.selectedDate.holidayName = existingSpecialDate.holidayName || '';
      } else {
        // 如果没有找到对应条目，则设置默认值
        this.selectedDate.id = undefined;
        const status = this.getSpecialStatus(data);
        // 周末是前端的默认状态，保存时使用现有表单中的“休息”状态。
        this.selectedDate.status = status.value === 'weekend' ? 'rest' : status.value;
        this.selectedDate.holidayName = ''; // 默认节日名称为空
      }

      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    delDateStatus(id) {
      this.$http.post(this.enumApis.del, { ids: [id] }).then(() => {
        this.fetchSpecialDates();
        this.dialogVisible = false;
        this.$message.success('重置成功');
      }).catch(() => {
        this.$message.error('重置失败');
      });
    },
    saveDateStatus() {
      // 这里可以添加保存逻辑，比如发送到服务器更新特殊日期列表
      // 更新本地的 specialDates 数据
      const index = this.specialDates.findIndex(item => item.date === this.selectedDate.day);
      const holidayName = this.selectedDate.holidayName || '';
      if (index > -1) {
        this.$set(this.specialDates, index, {
          id: this.selectedDate.id,
          date: this.selectedDate.day,
          status: this.selectedDate.status,
          isRest: ['rest', 'weekend', 'holiday-rest'].includes(this.selectedDate.status),
          holidayName
        });
      } else {
        this.specialDates.push({
          id: this.selectedDate.id,
          date: this.selectedDate.day,
          status: this.selectedDate.status,
          isRest: ['rest', 'weekend', 'holiday-rest'].includes(this.selectedDate.status),
          holidayName
        });
      }
      // id
      // holidayName  名称 this.selectedDate
      // date    日期
      // status   状态：  rest休班  adjustment调休 weekend周末 holiday-rest节假日休息   holiday-work节假日上班   work工作日
      // isRest 是否休息 0否 1是
      const params = {
        id: this.selectedDate.id,
        dateStr: this.selectedDate.day,
        status: this.selectedDate.status,
        isRest: Number(['rest', 'weekend', 'holiday-rest'].includes(this.selectedDate.status)),
        holidayName
      }
      this.$http.post(this.enumApis.add, params).then(res => {
        this.fetchSpecialDates();
        this.dialogVisible = false;
        this.$message.success('保存成功');
      }).catch(() => {
        this.$message.error('保存失败');
      });
    }
  },
  mounted() {
    this.fetchSpecialDates();
  }
};
</script>

<style scoped lang="less">
.adjustment-day {
  color: #ffdc00;
}

.rest-day,
.weekend-restday {
  color: red;
}

.japan-office-rest {
  color: #409eff;
}

.holiday-work {
  color: #ffdc00;
}

.workday {
  color: black;
}

.sp-index__calendar {

  &-left {
    position: relative;
  }

  &-legend {
    position: absolute;
    z-index: 2;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 28px;
    flex-wrap: nowrap;
    gap: 12px;
    max-width: calc(100% - 320px);
    overflow: hidden;
    white-space: nowrap;

    & > span {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      color: #606266;
      font-size: 13px;
    }
  }

  &- {
  
    &item {
      position: relative;
      text-align: center;
      padding-top: 15px;
      width: 100%;
      height: 100%;

    }

    &work,
    &reset {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      border-radius: 3px;
      text-align: center;
      font-size: 12px;
      color: #fff;
    }

    &work {
      background: gray;
    }

    &reset {
      background: red;
    }

    &reset.office-reset {
      background: #409eff;
    }
  }
}

.calendar-cell-tooltip {
  display: block;
  width: 100%;
  height: 100%;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  border-radius: 2px;
}

.legend-rest { background-color: red; }
.legend-office-rest { background-color: #409eff; }
.legend-holiday-work { background-color: #ffdc00; }
.legend-work { background-color: black; }
</style>

<style lang="less">
.calendar-description-tooltip {
  max-width: 320px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
